"use strict";

import BaseModel from "@/shared/lib/client-sdk/base-model";
import ApiRequest from "@/shared/lib/client-sdk/api-request";
import $ from "jquery";

class OfacFileVersion extends BaseModel {
  constructor(idOrAttributes, onRefreshCallback = null) {
    super(idOrAttributes, onRefreshCallback);
  }

  static getModelClassName() {
    return "OfacFileVersion";
  }

  static getApiPathForSearch() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/private/legal/ofac-file-versions"
    );
  }

  getApiPathForCreate() {
    console.error("Cannot create OFAC file versions.");
  }

  getApiPathForRefreshUpdateAndDelete() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/private/legal/ofac-file-versions/" +
      this.id
    );
  }

  getAdminPath() {
    console.error("Cannot go to an OFAC file version.");
  }

  get searchResultTitle() {
    return this.s3Key || this.id;
  }

  // Returns a string, or an array of strings (for a multi-line subtitle)
  get searchResultSubtitle() {
    return null;
  }

  get searchResultCreatedAt() {
    return this.pulledAtUtc;
  }

  get searchResultStatus() {
    return this.status;
  }

  downloadExcelFile(callback) {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/private/legal/ofac-file-versions/" +
      this.id +
      "/download-excel";

    ApiRequest.send("GET", requestUrl).onComplete(
      function (response) {
        if (response.successful) {
          if ($.isFunction(callback)) callback(response.result, null);
        } else {
          if ($.isFunction(callback)) callback(null, response.message);
        }
      }.bind(this)
    );
  }
}

export default OfacFileVersion; 